export { default } from "./Figure";
export { default as rehydrator } from "./Figure.rehydrator";